import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useFetchImage from "../hooks/useFetchImage";
import useFetchStands from "../hooks/useFetchStands";
import LayoutImage from "../components/LayoutImage";
import Loading from "../components/Loading";
import { Container, Alert, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAppContext } from "../context/AppContext";
import getCode from "../utils/utilFunction";
import { pavilions } from "../utils/pavilionCoordinates";

const StandPage = ({ encryptedData }) => {
  const urlParams = useParams();
  const { setExhibition, setPavCode, setStandCode } = useAppContext();
  const navigate = useNavigate();

  // Use encrypted data if provided, otherwise use URL params
  const ExCode = encryptedData?.ExCode || urlParams.ExCode;
  const PavCode = encryptedData?.PavCode || urlParams.PavCode;
  const paramStandCode = encryptedData?.standCode || urlParams.standCode;
  const newStandCode = paramStandCode ? paramStandCode.replace(/----/g, "/") : "";
  const PavCodeFinal = PavCode ? getCode(PavCode) : "";

  useEffect(() => {
    if (ExCode) setExhibition(ExCode);
    if (PavCodeFinal) setPavCode(PavCodeFinal);
    if (newStandCode) setStandCode(newStandCode);
  }, [ExCode, PavCodeFinal, newStandCode, setExhibition, setPavCode, setStandCode]);
  const { imageUrl, loading: imageLoading } = useFetchImage(ExCode, PavCodeFinal);
  const { stands, loading: standsLoading } = useFetchStands(ExCode, PavCodeFinal);

  // Check if pavilion has coordinates
  const pavilionHasCoordinates =
    pavilions.some((pav) => pav.id === PavCodeFinal) ||
    pavilions.some((pav) => pav.id === PavCodeFinal.replace(/ΙΣ$|ΟΡ$/, ""));

  const handleViewOnMap = () => {
    navigate(`/${ExCode}/${PavCode}/map`);
  };

  if (imageLoading || standsLoading) return <Loading />;

  return (
    <Container className="text-center mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h1>Pavilion: {PavCode}</h1>
          <h2>Stand: {newStandCode}</h2>
        </div>
        {pavilionHasCoordinates ? (
          <Button variant="success" onClick={handleViewOnMap}>
            View Pavilion on Map
          </Button>
        ) : (
          <OverlayTrigger
            placement="left"
            overlay={
              <Tooltip>
                Map coordinates not available for this pavilion
              </Tooltip>
            }
          >
            <span className="d-inline-block">
              <Button variant="secondary" disabled style={{ pointerEvents: "none" }}>
                View Pavilion on Map
              </Button>
            </span>
          </OverlayTrigger>
        )}
      </div>

      {imageUrl ? (
        <div className="mt-4">
          <LayoutImage
            imageUrl={imageUrl}
            stands={stands || []}
            targetStand={newStandCode}
          />
          <div className="mt-3">
            <small className="text-muted">
              Showing {stands.length} stands. {stands.length === 0 ? "No stand data available." : ""}
            </small>
          </div>
        </div>
      ) : (
        <Alert variant="warning">No image available</Alert>
      )}
    </Container>
  );
};

export default StandPage;